import * as listagem from '@/api/listagem'
import { clone, maskFloat } from '@/service/util'

const state = {
  list: [],
  listaSelect: [],
  filtros: { page: 1 },
  countPage: 0,
  modalAdd: false,
  modalDetalhes: false,
  modalAuxilioDetalhes: false,
  modalConfDelLista: false,
  modalConfDesativa: false,
  modalImportarClientes: false,
  modalEditUsuarios: false
}

const mutations = {
  SETLISTAS (state, data) {
    state.list = data.list
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  HIDDEMODAL (state) {
    state.modalAdd = false
    state.modalDetalhes = false
    state.modalAuxilioDetalhes = false
    state.modalConfDelLista = false
    state.modalConfDesativa = false
    state.modalImportarClientes = false
    state.modalEditUsuarios = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALDETALHES (state) {
    state.modalDetalhes = !state.modalDetalhes
  },
  MODALDETALHESAUXILIO (state) {
    state.modalAuxilioDetalhes = !state.modalAuxilioDetalhes
  },
  MODALCONFDELLISTA (state) {
    state.modalConfDelLista = !state.modalConfDelLista
  },
  MODALCONFDESATIVA (state) {
    state.modalConfDesativa = !state.modalConfDesativa
  },
  MODALIMPORTARCLIENTES (state) {
    state.modalImportarClientes = !state.modalImportarClientes
  },
  MODALEDITUSUARIOS (state) {
    state.modalEditUsuarios = !state.modalEditUsuarios
  }
}

const actions = {
  async getListasUnidade ({ commit }, payload) {
    let data = await listagem.listPorUnidade(payload)
    return data
  },
  async getListas ({ state, commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await listagem.getListas(payload)
    commit('SETLISTAS', data.instancia)
    commit('SETPAGINATE', data.instancia.pages)
  },
  async getListasFiltro ({ commit, dispatch }) {
    let data = await listagem.getListas(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.instancia.pages)
    else {
      commit('SETLISTAS', data.instancia)
      commit('SETPAGINATE', data.instancia.pages)
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getListas', state.filtros)
  },
  async get ({ commit }, payload) {
    let data = await listagem.get(payload)
    return data.instancia
  },
  async getUsuarios ({ commit }, payload) {
    let data = await listagem.getUsuarios(payload)
    return data.instancia
  },
  async add ({ commit }, payload) {
    if (payload.cidade !== null) payload.cidade.id = payload.cidade.value
    if (payload.instituicao !== null) payload.instituicao.id = payload.instituicao.value
    let dados = clone(payload)
    dados.valor_parcela.minimo = maskFloat(dados.valor_parcela.minimo)
    dados.valor_parcela.maximo = maskFloat(dados.valor_parcela.maximo)
    dados.salario.minimo = maskFloat(dados.salario.minimo)
    dados.salario.maximo = maskFloat(dados.salario.maximo)
    dados.margem.minima = maskFloat(dados.margem.minima)
    dados.margem.maxima = maskFloat(dados.margem.maxima)

    if (dados.cidades) {
      dados.cidades.forEach(cidade => {
        cidade.id = cidade.value
      })
    }

    if (dados.instituicoes) {
      dados.instituicoes.forEach(banco => {
        banco.id = banco.value
      })
    }

    if (dados.usuarios) {
      dados.usuarios.forEach(user => {
        user.id = user.value
      })
    }

    return listagem.add(dados)
  },
  async del ({ commit }, payload) {
    try {
      let retorno = await listagem.del(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  async editStatus ({ commit }, payload) {
    return listagem.editStatus(payload)
  },
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalDetalhes: function ({ commit }) {
    commit('MODALDETALHES')
  },
  modalAuxilioDetalhes: function ({ commit, state }) {
    commit('MODALDETALHESAUXILIO')
  },
  modalConfDelLista: function ({ commit }) {
    commit('MODALCONFDELLISTA')
  },
  modalConfDesativa: function ({ commit }) {
    commit('MODALCONFDESATIVA')
  },
  modalImportarClientes: function ({ commit }) {
    commit('MODALIMPORTARCLIENTES')
  },
  importarClientesParaCampanha: async function ({ commit }, payload) {
    let retorno = await listagem.importarClientesParaCampanha(payload)
    return retorno.instancia
  },
  async exportar ({ commit }, payload) {
    const retorno = await listagem.exportar(payload)
    return retorno.instancia
  },
  modalEditUsuarios: function ({ commit }) {
    commit('MODALEDITUSUARIOS')
  },
  async editarUsuarios ({ commit }, payload) {
    return listagem.editarUsuarios(payload)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/listagem.js